import React, { useMemo } from 'react';
import { useFormikContext } from 'formik';

import { Grid } from '@material-ui/core';
import Field from 'core/components/form/form.v2';
import { brandConstants } from 'brand-config';

import useStyles from './disclaimer.styles';

const getDisclaimerText = (state, classes) => {
  const isTexas = state === 'TX';

  return (
    <>
      I, as a {brandConstants.SHORT_NAME} sales representative, assert that I have disclosed the following to the client
      on whose behalf I am obtaining this offer and the client agreed and instructed me to proceed: <br />
      <br />
      "To provide an accurate Price, we’ll ask you for information about yourself and your household, as well as gather
      information from third parties, such as your claims, driving, and credit information, including a credit report.
      To provide the best service, we will also share your personal information with service providers, who act on our
      behalf, other insurance carriers we have partnered with, or others operating at your discretion or where legally
      necessary or appropriate. Our Privacy Policy can be found on our website{' '}
      <a href={`https://${brandConstants.DOMAIN}`} className={classes.link} target="_blank" rel="noopener noreferrer">
        {brandConstants.DOMAIN}
      </a>{' '}
      and by proceeding you agree to its terms.
      {isTexas && (
        <>
          {' '}
          A copy of the Texas Use of Credit Disclosure is available at{' '}
          <a
            className={classes.link}
            href={`https://${brandConstants.DOMAIN}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {brandConstants.DOMAIN}
          </a>
          .
        </>
      )}{' '}
      Would you like to proceed?"
    </>
  );
};

const Disclaimer = () => {
  const classes = useStyles();
  const { values } = useFormikContext();
  const disclaimerText = useMemo(() => getDisclaimerText(values.state, classes), [values.state, classes]);

  return (
    <Grid container item className={classes.checkboxContainer}>
      <Field
        className={classes.checkbox}
        type="checkbox"
        name="fcraDisclaimer"
        id="fcraDisclaimer"
        label={disclaimerText}
        mode="light"
        fast={false}
        topAlignCheckbox
      />
    </Grid>
  );
};

export default Disclaimer;
